import React, { useEffect } from 'react';
import Dashboard from '../../components/Dashboard/v2/Dashboard';
import UserRole from '../../../shared/AuthRoles';
import { Navigate } from 'react-router-dom';
import { ContractorRole } from '../../enums/users';

export default function DashboardPage() {
    const loggedInUser = UserRole();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return loggedInUser.role === ContractorRole.User ? (
        <Navigate to={'/jobs'} replace />
    ) : (
        <Dashboard />
    );
}
